import { render, staticRenderFns } from "./confirmReminderDialog.vue?vue&type=template&id=53bd24d7&scoped=true"
import script from "./confirmReminderDialog.vue?vue&type=script&lang=js"
export * from "./confirmReminderDialog.vue?vue&type=script&lang=js"
import style0 from "./confirmReminderDialog.vue?vue&type=style&index=0&id=53bd24d7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bd24d7",
  null
  
)

export default component.exports